import React, { useMemo } from "react";

// ----------------------------------------------------------------------------

export default function AppButton(props) {
  const { style, onClick, children } = props;

  return (
    <button
      onClick={onClick}
      style={{ border: "none", backgroundColor: "white", padding: 0, ...style }}
    >
      {children}
    </button>
  );
}

// ----------------------------------------------------------------------------
